<template>
  <div class="signture_container">
    <!-- 表格 -->
    <el-dialog title="下载考生签名" :visible.sync="dialogTableVisible" :before-close="close" :close-on-click-modal="false">
      <span class="subhead" style="margin-left: 5px; color: #666666; font-size: 16px; position: absolute; top: 24px; left: 125px">（提示：导出任务已提交，关闭不影响导出）</span>
      <div class="table_wrapper">
        <div class="table_content">
          <el-table border :data="signatureList" max-height="550" :cell-style="cellStyle">
            <el-table-column prop="serial" width="60" label="序号"></el-table-column>
            <el-table-column prop="fileName" width="130" label="批次名称"></el-table-column>
            <el-table-column label="导出进度">
              <template slot-scope="{row}">
                <el-progress class="progressArea" :text-inside="true" :color="customColorMethod" :stroke-width="15" :percentage="100*(row.handledNumber / row.totalNumber)" :format="formatPercentage"></el-progress>
              </template>
            </el-table-column>
            <el-table-column prop="startTime" width="170" label="导出时间"></el-table-column>
            <el-table-column prop="endTime" width="170" label="完成时间"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="{row}">
                <div class="table_content_operation">
                  <!-- 下载 -->
                  <el-tooltip class="item" effect="dark" content="下载" placement="bottom">
                    <img v-if="row.status == 'finish'" class="operation_img" @click="downloadSignture(row)" src="@/assets/image/download.png"/>
                  </el-tooltip>
                  <!-- 删除 -->
                  <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                    <img class="operation_img" @click="deleteSignture(row)" src="@/assets/image/batchSignUp/icon_delete.png" />
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="page_footer">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[12, 24, 48, 360]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="count">
        </el-pagination>
      </div>
      <div class="button_box">
          <el-button @click="onRefreshBtnClicked">刷新</el-button>
          <el-button type="primary" @click="onCloseBtnClicked">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog style="height: 350px;margin-top:10%;overflow: hidden" title="提示" :visible.sync="deleteDialogVisible" :before-close="close" :close-on-click-modal="false" width="30%" center>
      <span style="text-align:center; font-size: 16px">确定要删除这条数据吗?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onCancel">取 消</el-button>
        <el-button type="primary" @click="onConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "signature",
  data() {
    return {
      dialogTableVisible: false,
      deleteDialogVisible: false,
      list:[],
      page: 1,
      limit: 12,
      deleteRow: {},
      filePath: '',
      exportStatusObj:{
        processing: '正在导出',
        failed: '导出失败',
        finish: '已完成',
      },
      signatureList: [], // 考生签名信息列表
      count: 0, // 考生签名信息列表数据的条数
      exportProgressTimer: null
    }
  },
  beforeDestroy () {
    this.clearExportProgressTimer()
  },
  methods: {
    formatPercentage(percentage){
      let percent = ''
      if(percentage !== 0 && percentage !== 100){
        percent =  percentage.toFixed(2) + '%'
      }else{
        percent = percentage + '%'
      }
      return percent
    },
    customColorMethod(percentage) {
      if (percentage < 30) {
        return '#909399';
      } else if (percentage < 70) {
        return '#e6a23c';
      } else {
        return '#67c23a';
      }
    },
    cellStyle: function(row) {
      if(row.column.label === '导出进度' && row.row.statusText === "正在导出"){
        return 'color:#54B0FB'
      }
      if(row.column.label === '导出进度' && row.row.statusText === "导出失败"){
        return 'color:#E02020'
      }
      if(row.column.label === '导出进度' && row.row.statusText === "已完成"){
        return 'color:#4D4D4D'
      }
    },
    // 改变每一页展示的数据的条数
    handleSizeChange(val) {
      this.page = 1
      this.limit = val
      this.getTaskList()
    },

    // 改变当前的页码
    handleCurrentChange(val) {
      this.page = val
      this.getTaskList()
    },


    // 获取导出考生签名的任务列表
    getTaskList(){
      let param = {
        page: this.page,
        size: this.limit
      }
      this.$http.get(`/fileTask/tasks`, {params: param}).then((res) => {
        if(res.data.success){
          this.signatureList = res.data.data.data
          this.count = res.data.data.count
          this.signatureList.forEach((item, index) => {
            item.serial = (param.page - 1) * param.size + (index + 1)
            item.statusText = this.exportStatusObj[item.status]; 
            // 格式化时间: 去掉导出时间中的 T
            item.startTime = item.startTime.split('T')[0] + ' ' + item.startTime.split('T')[1].split('.')[0]
            // 格式化时间: 去掉完成时间中的 T
            if(item.endTime){
              item.endTime = item.endTime.split('T')[0] + ' ' + item.endTime.split('T')[1].split('.')[0]
            }
          })
        }
      })
    },

    // 每隔 2 分钟 轮询一次, 获取导出进度
    createExportProgressTimer: function(){
      clearInterval(this.exportProgressTimer)
      this.exportProgressTimer = setInterval(() => {this.getTaskList()}, 2000)
    },

    // 清除定时器
    clearExportProgressTimer: function(){
      clearInterval(this.exportProgressTimer)
      this.exportProgressTimer = null
    },

    // 下载签名
    downloadSignture(row){
      this.$http.get(`/fileTask/download/${row.id}`).then((res) => {
        if (res.data.success){
          this.filePath = this.$server.qxyRes + res.data.data.path
          window.open(this.filePath) // 打开网址，让用户下载签名
        }
      })
    },

    // 删除
    deleteSignture(row){
      this.deleteDialogVisible = true
      this.deleteRow = row
    },

    // 确定
    onConfirm(){
      if(this.signatureList.length > 0){
        this.$http.delete(`/fileTask/${this.deleteRow.id}`).then((res) => {
          if (res.data.success && res.status == 200){
            this.$message.success('删除成功')
            this.getTaskList()
          }
        })
        this.deleteDialogVisible = false
      }
    },

    // 取消
    onCancel(){
      this.deleteDialogVisible = false
     
    },

    // 刷新数据
    onRefreshBtnClicked(){
      this.getTaskList()
    },

    // 关闭
    onCloseBtnClicked(){
      this.clearExportProgressTimer() // 清除定时器
      this.dialogTableVisible = false
      this.page = 1
      
    },
    
    // 关闭弹框
    close(done){
      this.clearExportProgressTimer() // 清除定时器
      done()
      this.page = 1
    }
  }
}
</script>

<style lang="less" scoped>
.signture_container{
    width: 100%;
    height: 400px;
    min-height: 200px;
    max-height: 350px;
    .button_box{
        position: absolute;
        right: 40px;
        bottom: 50px;
    }
}
.table_wrapper {
  flex: 1;
  width: 100%;
  margin: 0;
  height: 650PX;
  position: relative;
  .table_content {
    position: absolute;
    width: 100%;
    margin: 0;
    .table_content_operation{
      display: flex;
      justify-content: center;
    }
  }
}
.page_footer{
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 25px;
  left: -260px;
}
.operation_img {
  width: 25PX !important;
  height: 25PX !important;
  display: block;
  margin: 0 3PX
}
::v-deep .el-dialog__headerbtn {
    position: absolute;
    top: 16px;
    right: 20px;
    padding: 0;
    background: 0 0;
    border: none;
    outline: 0;
    cursor: pointer;
    font-size: 30px !important;
}
::v-deep .el-dialog__title {
  line-height: 32px !important;
  font-size: 18px;
  font-weight: 600;
  color: #373737;
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: #909399;
  font-size: 30px !important;
  ::v-deep .el-icon-close:before {
    content: "\E6DB";
    font-size: 30px !important;
  }
}
::v-deep .el-button {
  width: 80px;
}
::v-deep .el-dialog--center .el-dialog__body {
  text-align: center;
  padding: 25px 25px 30px;
  font-size: 16px;
}
::v-deep .el-progress .progressArea{
  stroke: #004394 !important; 
}
</style> 